//
// Lightbox
//

import {a11yText} from './A11yText';
import GLightbox from 'glightbox';

const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container" aria-live="polite" aria-atomic="true">
    <div class="gloader visible"></div>
    <div class="goverlay"></div>
    <div class="gcontainer">
        <div id="glightbox-slider" class="gslider"></div>
        <div class="glightbox-btn-wrap">
            <button class="gnext gbtn" tabindex="0" aria-label="` + a11yText.lightboxNext + `">{nextSVG}</button>
            <button class="gprev gbtn" tabindex="0" aria-label="` + a11yText.lightboxPrev + `">{prevSVG}</button>
        </div>
        <button class="gclose gbtn" tabindex="0" aria-label="` + a11yText.lightboxClose + `">{closeSVG}</button>
    </div>
</div>`;

const lightbox = GLightbox({
    selector: '.glightbox',
    touchNavigation: true,
    loop: true,
    title: 'data-title',
    svg: {
        next: '',
        prev: '',
        close: '',
    },
    lightboxHTML: customLightboxHTML,
});

lightbox.close();

const page = document.getElementById('page');

lightbox.on('open', () => {
    page.setAttribute('aria-hidden', 'true');
    let glightboxButton = document.querySelectorAll('.ginner-container .glightbox.svg');

    if (typeof (glightboxButton) != 'undefined' && glightboxButton != null) {
        glightboxButton.forEach(function (el) {
            el.remove();
        });
    }
});

lightbox.on('close', () => {
    page.removeAttribute('aria-hidden');
});

export default {};
